var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3967 24.8184C16.7458 27.6698 15.6224 31.5798 15.4127 35.9964L34.3343 35.9964C34.1246 31.5798 33.0012 27.6698 31.3504 24.8184C29.492 21.6084 27.1486 20.0037 24.8735 20.0037C22.5985 20.0037 20.2551 21.6084 18.3967 24.8184ZM35.8396 35.9964C35.3958 26.2059 30.6557 18.5 24.8735 18.5C19.0914 18.5 14.3513 26.2059 13.9075 35.9964C13.885 36.4925 13.8735 36.9939 13.8735 37.5H35.8735C35.8735 36.9939 35.8621 36.4925 35.8396 35.9964Z",
    fill: "#0C2487"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9324 15.2871C26.8701 15.2871 28.4409 13.7163 28.4409 11.7786C28.4409 9.84089 26.8701 8.27008 24.9324 8.27008C22.9947 8.27008 21.4239 9.84089 21.4239 11.7786C21.4239 13.7163 22.9947 15.2871 24.9324 15.2871ZM24.9324 16.7908C27.7005 16.7908 29.9446 14.5467 29.9446 11.7786C29.9446 9.01045 27.7005 6.76643 24.9324 6.76643C22.1643 6.76643 19.9202 9.01045 19.9202 11.7786C19.9202 14.5467 22.1643 16.7908 24.9324 16.7908Z",
    fill: "#0C2487"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.87891 2.00488H4.38256V37.5913H2.87891V2.00488Z",
    fill: "#0C2487"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89376 2.00488H10.3974V37.5913H8.89376V2.00488Z",
    fill: "#0C2487"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64521 36.0876V37.5913H3.63061L3.63061 36.0876L9.64521 36.0876Z",
    fill: "#0C2487"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2053 2.00488V3.50854L3.63105 3.50853L3.63105 2.00488L34.2053 2.00488Z",
    fill: "#0C2487"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1394 8.5207V10.0244H3.38028L3.38028 8.5207H7.1394Z",
    fill: "#0C2487"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1394 15.5378V17.0414H3.38028L3.38028 15.5378H7.1394Z",
    fill: "#0C2487"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1394 22.0536V23.5572H3.38028L3.38028 22.0536H7.1394Z",
    fill: "#0C2487"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1394 29.0706V30.5742H3.38028L3.38028 29.0706L7.1394 29.0706Z",
    fill: "#0C2487"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88601 5.26279V6.76739H4.13064V5.26279H5.88601Z",
    fill: "#0C2487"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88601 12.2798V13.7844H4.13064V12.2798H5.88601Z",
    fill: "#0C2487"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88601 18.7956V20.3002H4.13064V18.7956H5.88601Z",
    fill: "#0C2487"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88601 25.8127V27.3173H4.13064V25.8127L5.88601 25.8127Z",
    fill: "#0C2487"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88601 32.5791V34.0837H4.13064V32.5791L5.88601 32.5791Z",
    fill: "#0C2487"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeight);
export default __webpack_public_path__ + "static/media/height.16ddac115786083ea02e27cc767e824a.svg";
export { ForwardRef as ReactComponent };